import { render, staticRenderFns } from "./citation-entry-unavailable.vue?vue&type=template&id=244bda7b"
import script from "./citation-entry-unavailable.vue?vue&type=script&lang=ts"
export * from "./citation-entry-unavailable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_css-loader@4.3.0_webpack@4.46.0__ejs@3.1.10_0212d38a6ce0de8ef75b0a1c6dc51def/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports